import React from "react";
import ReportQuestionDetail from "../../../components/organisms/admin/report/ReportQuestionDetail";

type Props = {};

const ReportQuestionDetailPage = (props: Props) => {
	return <ReportQuestionDetail />;
};

export default ReportQuestionDetailPage;
